module.exports = __webpack_public_path__ + "d6413ba1/img/grid-web-icon.d0395d64.svg";